import React from 'react';
import HedinIcon from '@hedinbil/hedin-ui/dist/icons/components/HedinIcon';
import Card from '../Card/Card';

const SalesPersonCard = (props) => {
  const { adId, email, firstName, lastName, locationId, phone, title } = props;
  const teleHref = 'tel:' + phone;
  const mailHref = 'mailto:' + email;

  return (
    <Card className="sales-person-card fw-400 d-flex bg-white">
      <div>
        <div className="sales-person-card__image"></div>
      </div>
      <div>
        <p className="site-list__item-title h-mb-2 text-uppercase color-black">
          {firstName} {lastName}
        </p>
        <p className="sales-person-card__text color-black">{title}</p>
        {email && (
          <div>
            <a href={mailHref} className="contact-link fw-400 d-flex text-lowercase">
              <HedinIcon iconName="Mail" />
              {email}
            </a>
          </div>
        )}
        {phone && (
          <div>
            <a href={teleHref} className="contact-link fw-400 d-flex">
              <HedinIcon iconName="Phone" />
              <span>{phone}</span>
            </a>
          </div>
        )}
      </div>
    </Card>
  );
};

export default SalesPersonCard;
